Getaways = window.Getaways ?= {}
Getaways.Calendar ?= {}
Affirm = require '../../affirm_info/frontend/affirm'
GetawaysBookingCalendar = require '../../../node_modules/booking-calendar/dist/getaways-calendar.js'

Getaways.Calendar.init = ({calendar}, done) ->
  return done() unless calendar

  Groupon.Getaways.$ ->
    _.extend calendar,
      settings: ['rooms', 'adults']
      imageUrl: 'getaways-'
      inventoryUrl: "#{payload.rootUrl}/inventory_proxy"
      locales:
        localizer: I18n.translate
        prefix: "js.modules.getaways.booking_calendar."
        obj: I18n
      eventHandler: (object) ->
        OptimizeSuite.TrackingHub.add 'bookingCalendar', object
        handleInventoryFailure object
        handleCalendarRender object
        handleCalendarPriceUpdate object

      renderCallback: ->
        done()

    configuration = new Groupon.Getaways.Views.CalendarConfiguration(calendar)
    instance = new Groupon.Getaways.Views.Calendar({configuration})

handleCalendarPriceUpdate = (object) ->
  return unless object.message.indexOf("Price:Updated") > 0
  return unless object.subtotalPrice?
  Affirm.updateAffirmPrice(object.subtotalPrice * 100)

handleCalendarRender = (object) ->
  return unless object.message.indexOf("Calendar:Render:End") > 0
  Affirm.displayBannerInCalendar()

handleInventoryFailure = (object) ->
  if object.message.indexOf("Inventory:Request:Empty") > 0 or object.message.indexOf("Inventory:Request:Failure") > 0
    Affirm.removeBanner()

module.exports = Getaways.Calendar
